// extracted by mini-css-extract-plugin
export default {"ActionContainer":"ReportDownloads_ActionContainer__C15Gh","Action":"ReportDownloads_Action__vkOO4","Delete":"ReportDownloads_Delete__xiW46"};